import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  errorCodes: {},
  isLoading: false,
  error: "",
  hasData: false
};
const errorCodeSlice = createSlice({
  name: "checkinErrorCodes",
  initialState,
  reducers: {
    errorCodeRequest: state => {
      state.isLoading = true;
    },
    errorCodeSuccess: (state, action) => {
      state.isLoading = false;
      state.error = "";
      state.hasData = true;
      state.errorCodes = action.payload;
    },
    errorCodeFailure: (state, action) => {
      state.error = action.payload;
      state.isLoading = false;
    }
  }
});
export const {
  errorCodeRequest,
  errorCodeSuccess,
  errorCodeFailure
} = errorCodeSlice.actions;
export default errorCodeSlice.reducer;